export const barData = {
    labels: ["Transportation", "E-Commerce", "Public Sector", "Agriculture", "Construction", "Aviation"],
    datasets: [{
        label: 'Top Performing Ecosystems %',
        data: [75, 45, 35, 50, 25, 5],
        backgroundColor: [
            'rgba(255, 99, 132, 1)',
            'rgba(54, 162, 235, 1)',
            'rgba(255, 206, 86, 1)',
            'rgba(75, 192, 192, 1)',
            'rgba(153, 102, 255, 1)',
            'rgba(255, 159, 64, 1)'
        ],
        borderColor: [
            'rgba(255,99,132,1)',
            'rgba(54, 162, 235, 1)',
            'rgba(255, 206, 86, 1)',
            'rgba(75, 192, 192, 1)',
            'rgba(153, 102, 255, 1)',
            'rgba(255, 159, 64, 1)'
        ],
        borderWidth: 1
    }]
  };

  export const doughnutData = {
    labels: ["Paid", "Unpaid"],
    datasets: [{
        data: [75, 25],
        backgroundColor: [
            'rgba(255, 99, 132, 1)',
            'rgba(75, 192, 192, 1)'
        ],
        borderColor: [
            'rgba(255,99,132,1)',
            'rgba(75, 192, 192, 1)'
        ],
        borderWidth: 1
    }]
  };

  export const doughnutData2 = {
    labels: ["Successful(75%)", "Failed(25%)"],
    datasets: [{
        data: [75, 25],
        backgroundColor: [
            'rgba(54, 162, 235, 1)',
            'rgba(255, 206, 86, 1)'
        ],
        borderColor: [
            'rgba(54, 162, 235, 1)',
            'rgba(255, 206, 86, 1)'
        ],
        borderWidth: 1
    }]
  };

  export const lineData = {
    labels: ["January", "February", "March", "April"],
    datasets: [{
        label: 'Total Earnings %',
        data: [1.7, 1.8, 2.0, 1.9],
        backgroundColor: [
            'rgba(255, 206, 86, 0.5)',
            'rgba(75, 192, 192, 0.5)',
            'rgba(153, 102, 255, 0.5)',
            'rgba(255, 159, 64, 0.5)'
        ],
        borderColor: [
            'rgba(255, 206, 86, 1)',
            'rgba(75, 192, 192, 1)',
            'rgba(153, 102, 255, 1)',
            'rgba(255, 159, 64, 1)'
        ],
        borderWidth: 1
    }]
  };

  export const investmentLineData = {
    labels: ["Max.ng", "Riby", "ESL"],
    datasets: [{
        label: 'Total Investment \'millions',
        data: [1.7, 2.0, 1.4],
        backgroundColor: [
            'rgba(255, 206, 86, 0.5)',
            'rgba(75, 192, 192, 0.5)',
            'rgba(153, 102, 255, 0.5)',
            'rgba(255, 159, 64, 0.5)'
        ],
        borderColor: [
            'rgba(255, 206, 86, 1)',
            'rgba(75, 192, 192, 1)',
            'rgba(153, 102, 255, 1)',
            'rgba(255, 159, 64, 1)'
        ],
        borderWidth: 1
    }]
  };